import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const CITIES = {
  "Vale do Paraíba (SP)": [
    "São José dos Campos", "Jacareí", "Taubaté", "Caçapava", "Pindamonhangaba",
    "Guaratinguetá", "Aparecida", "Lorena", "Cruzeiro", "Cachoeira Paulista",
    "São Sebastião", "Ubatuba", "Caraguatatuba",
  ],
  "Grande São Paulo & Interior": [
    "São Paulo Capital", "Campinas", "Sorocaba", "Ribeirão Preto", "Santos",
    "ABC Paulista", "Baixada Santista",
  ],
  "Atendimento Nacional": [
    "Rio de Janeiro", "Minas Gerais", "Paraná", "Santa Catarina",
    "Rio Grande do Sul", "Espírito Santo", "Bahia", "Todos os estados",
  ],
};

export const ServiceArea = () => {
  return (
    <section id="atendimento" data-testid="section-atendimento" className="relative py-20 sm:py-24 bg-[#081726] border-y border-white/5">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 mb-10">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#2FA36B]" />
              <span className="font-condensed uppercase text-xs tracking-[0.4em] text-[#2FA36B] font-bold">Áreas de Atendimento</span>
            </div>
            <h2 className="font-condensed font-bold uppercase text-3xl sm:text-4xl lg:text-5xl text-white leading-[0.95] tracking-tight">
              Atendemos em todo o
              <span className="text-[#2FA36B]"> Brasil</span>, com base no
              <span className="text-[#2FA36B]"> Vale do Paraíba (SP)</span>.
            </h2>
          </div>
          <p className="lg:col-span-5 text-white/65 font-body text-base leading-relaxed">
            Nossas equipes de serviços críticos, treinamentos NR, resgate técnico e manutenção industrial atuam em obras, plantas e paradas em qualquer estado. Deslocamento rápido para operações no Vale do Paraíba, interior e capital de São Paulo.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-white/[0.07] border border-white/[0.07]">
          {Object.entries(CITIES).map(([region, cities], idx) => (
            <motion.div
              key={region}
              data-testid={`service-area-${idx}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: idx * 0.1 }}
              className="bg-[#12283F] p-6 sm:p-8"
            >
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 bg-[#2FA36B] flex items-center justify-center shrink-0">
                  <MapPin size={18} className="text-white" />
                </div>
                <h3 className="font-condensed font-bold uppercase text-base sm:text-lg text-white tracking-tight leading-tight">
                  {region}
                </h3>
              </div>
              <ul className="space-y-2">
                {cities.map((c) => (
                  <li key={c} className="flex items-start gap-2 text-white/75 font-body text-sm">
                    <span className="w-1 h-1 bg-[#2FA36B] mt-2 shrink-0" />
                    {c}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <p className="mt-10 text-center font-body text-sm text-white/50 max-w-3xl mx-auto leading-relaxed">
          Serviços de segurança do trabalho, NR 33, NR 35, alpinismo industrial, manutenção em altura, espaço confinado, resgate técnico, bombeiro civil, brigada de emergência, linhas de vida e serviços industriais críticos em qualquer localidade do Brasil.
        </p>
      </div>
    </section>
  );
};

export default ServiceArea;
